import usePrefix from '@/hooks/usePrefix';
import { IAirport, IGuide } from '@/types';
import { Button, Divider } from 'antd';
import Link from 'next/link';
import React, { ReactElement, useState } from 'react';

export interface IGuideList {
  airports: { result: IAirport[]; guides: IGuide[] };
  grid?: number;
  gap?: number;
}

function GuidesList({ airports, grid = 4, gap = 2 }: IGuideList): ReactElement {
  const prefix = usePrefix();
  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${grid} gap-y-2 gap-x-${gap} place-items-start`}
    >
      {airports?.guides?.map((guide: IGuide) => (
        <Link
          href={`${prefix}/guide/${guide.guide_friendly_url}`}
          key={guide.guide_id}
          className="text-primary hover:underline hover:text-primary"
          title={guide.guide_name}
        >
          »{guide.guide_name}
        </Link>
      ))}
    </div>
  );
}

function Guides({ airports }): ReactElement {
  const [showAllGuides, setShowAllGuides] = useState(false);
  return (
    <div className="container px-4 mx-auto">
      <div
        className={`shadow-sm overflow-hidden ${
          showAllGuides ? 'h-auto' : 'h-60 md:h-32'
        } rounded-md flex flex-col py-6 px-6 mt-8 mx-2 border`}
      >
        <div className="w-full grid grid-cols-1 md:grid-cols-3">
          <div className="col-span-2">
            <h2 className="text-2xl text-center md:text-left">Our Guides</h2>
            <p className="pt-2 lg:py-0 text-center md:text-left max-w-2xl">
              We've put together some great tips and highlights to help you
              explore and create great memories. No matter where you want to
              travel, or what your interests are, we're sure you'll find a
              destination to enjoy!
            </p>
          </div>
          <div className="flex justify-center mt-4 md:justify-end md:mt-0 items-center">
            <Button
              type="primary"
              size="large"
              className="rounded-full uppercase bg-primary"
              onClick={() => setShowAllGuides(!showAllGuides)}
            >
              {showAllGuides ? 'Hide Guides' : 'View All Guides'}
            </Button>
          </div>
        </div>

        <div
          className={`w-full pt-8 ${showAllGuides ? 'visible' : 'invisible'}`}
        >
          <Divider />
          <GuidesList airports={airports} />
        </div>
      </div>
    </div>
  );
}

export default Guides;
